export default __webpack_public_path__ + "static/media/tick.inline.8481dd6b.svg";